import { render, staticRenderFns } from "./file-picker-button.component.vue?vue&type=template&id=2a682d74&scoped=true&"
import script from "./file-picker-button.component.vue?vue&type=script&lang=ts&"
export * from "./file-picker-button.component.vue?vue&type=script&lang=ts&"
import style0 from "./file-picker-button.component.vue?vue&type=style&index=0&id=2a682d74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a682d74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
